module.exports = __webpack_public_path__ + "static/media/app2.55b9b2c7.png";